import { Button } from '@hausgold/designsystem';
import { map } from 'lodash-es';
import React, { Fragment, useContext } from 'react';
import { ApiContext, WizardContext } from 'fw-utils/contexts';
import analyticsTrack from 'fw-utils/tracking';
import FluidMaxContainer from '../components/FluidMaxContainer';
import WizardCard from '../components/WizardCard';
import {
  getHeadingText,
  getLineIcon,
  getLineIconSVG,
  getLineKeys,
  getLineTitle,
  getStepKeys,
} from '../services/models/dialog';

const Start = () => {
  const { data } = useContext(ApiContext);
  const { dialogId, leadId, recruiterId } = useContext(WizardContext);
  const {
    position,
    setCurrentLine,
    setCurrentStep,
    components: {
      WizardHeading,
      StartLayoutContainer,
      CustomNavigationButtonsStart,
      ChoiceOptionColContainer,
      ChoiceOptionRowContainer,
      CustomWizardCard,
    },
  } = useContext(WizardContext);

  const lines = getLineKeys(data);
  return (
    <Fragment>
      <WizardHeading>{getHeadingText(data)}</WizardHeading>
      <FluidMaxContainer>
        <StartLayoutContainer>
          <ChoiceOptionRowContainer>
            {map(lines, (key) => (
              <ChoiceOptionColContainer
                key={key}
                position={position}
                context="start"
              >
                <Button
                  as="a"
                  variant="unstyled"
                  role="link"
                  onClick={() => {
                    const firstStep = getStepKeys(data, key)[0];
                    const chosenLine = key;

                    analyticsTrack({
                      event: 'Formwizard Started',
                      params: {
                        dialog_id: dialogId,
                        lead_id: leadId,
                        recruiter_id: recruiterId,
                      },
                    });

                    analyticsTrack({
                      event: 'Formwizard Interacted',
                      params: {
                        dialog_id: dialogId,
                        lead_id: leadId,
                        recruiter_id: recruiterId,
                        label: getLineTitle(data, key),
                        step: `${chosenLine}-clickto_step${1}_${firstStep}`,
                      },
                    });

                    // Set chosen line
                    setCurrentLine(chosenLine);

                    // Set current step
                    setCurrentStep(firstStep);
                  }}
                >
                  {CustomWizardCard ? (
                    <CustomWizardCard
                      iconId={getLineIcon(data, key)}
                      iconSvg={getLineIconSVG(data, key)}
                      title={getLineTitle(data, key)}
                    />
                  ) : (
                    <WizardCard
                      iconId={getLineIcon(data, key)}
                      iconSvg={getLineIconSVG(data, key)}
                      title={getLineTitle(data, key)}
                    />
                  )}
                </Button>
              </ChoiceOptionColContainer>
            ))}
          </ChoiceOptionRowContainer>
          {CustomNavigationButtonsStart && <CustomNavigationButtonsStart />}
        </StartLayoutContainer>
      </FluidMaxContainer>
    </Fragment>
  );
};

export default Start;
